import { cn } from "@/lib/utils"

/**
 * Skeleton component displays a pulsing placeholder element used to indicate
 * loading content. Provides a visual placeholder while content is being loaded.
 * 
 * @component
 * @param {React.HTMLAttributes<HTMLDivElement>} props - Standard div element props
 * @param {string} [props.className] - Additional CSS classes
 * @returns {JSX.Element} Animated skeleton placeholder element
 * 
 * @example
 * ```tsx
 * <Skeleton className="h-4 w-full" />
 * ```
 * 
 * @example
 * ```tsx
 * <Skeleton className="h-12 w-12 rounded-full" />
 * ```
 */
function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn("animate-pulse rounded-md bg-primary/10", className)}
      {...props}
    />
  )
}

export { Skeleton }
